<template>
  <v-tooltip bottom :disabled="!isCancelled()">
    <template v-slot:activator="{ on }">
      <v-chip
        small
        outlined
        :color="chipInfo('color')"
        v-on="on"
      >
        <v-icon small left>{{ chipInfo('icon') }}</v-icon>

        {{ chipInfo('text') }}
      </v-chip>
    </template>

    <span>{{ getCancelReason() }}</span>
  </v-tooltip>

</template>
<script>
import { isEmpty, get  } from 'lodash'
import { convertTimestampToDate } from "../../services/util.service"
import moment from 'moment'

export default {
  props: {
    booking: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  methods: {
    getCancelReason() {
      return get(this.booking, 'cancelReason', '')
    },
    isCancelled() {
      return get(this.booking, 'isActive') === false
        && !isEmpty(get(this.booking, 'cancelledAt'))
    },
    isUpcoming() {
      const { startAt } = this.booking
      const startDate = convertTimestampToDate(startAt)
      const startMoment = moment(startDate)

      const todayEndOfDay = moment().endOf('day')

      return startMoment.isAfter(todayEndOfDay)
    },
    isToday() {
      const { startAt } = this.booking
      const startDate = convertTimestampToDate(startAt)
      const startMoment = moment(startDate)

      const todayEndOfDay =  moment().endOf('day')

      return startMoment.isSameOrBefore(todayEndOfDay, 'day')
    },
    isDone() {
      const { startAt } = this.booking
      const startDate = convertTimestampToDate(startAt)
      const startMoment = moment(startDate)

      const nowMoment =  moment()

      return startMoment.isSameOrBefore(nowMoment)
    },
    chipInfo(type) {
      const chipInfoMap = {
        cancelled: {
          color: 'error',
          icon: 'cancel',
          text: 'Cancelled'
        },
        upcoming: {
          color: 'info',
          icon: 'alarm',
          text: 'Upcoming'
        },
        today: {
          color: 'success',
          icon: 'calendar_today',
          text: 'Today'
        },
        done: {
          color: 'grey',
          icon: 'check_circle_outline',
          text: 'Past'
        }
      }

      if (this.isCancelled()) {
        return get(chipInfoMap, `cancelled.${type}`, '')
      } else if (this.isUpcoming()) {
        return get(chipInfoMap, `upcoming.${type}`, '')
      } else if (this.isDone()) {
        return get(chipInfoMap, `done.${type}`, '')
      } else if (this.isToday()) {
        return get(chipInfoMap, `today.${type}`, '')
      } else {
        // This condition should never be reached
        return ''
      }
    }
  }
}
</script>
